import { axiosInstanceReports } from '../config/axios-config'

export const convertHtmlToPdf = async (htmlContent: string) => {
  const response = await axiosInstanceReports.post(
    `/pdf/html_to_pdf_reports`,
    htmlContent,
    {
      headers: {
        'Content-Type': 'text/html',
      },
    }
  )
  return response.data.pdf_base64
}
